export let TYPES = /*#__PURE__*/function (TYPES) {
  TYPES["PRIMARY"] = "primary";
  TYPES["SECONDARY"] = "secondary";
  TYPES["CRITICAL"] = "critical";
  return TYPES;
}({});
export let TOKENS = /*#__PURE__*/function (TOKENS) {
  TOKENS["background"] = "background";
  TOKENS["backgroundHover"] = "backgroundHover";
  TOKENS["backgroundActive"] = "backgroundActive";
  TOKENS["foreground"] = "foreground";
  TOKENS["foregroundHover"] = "foregroundHover";
  TOKENS["foregroundActive"] = "foregroundActive";
  TOKENS["marginRightIcon"] = "marginRightIcon";
  return TOKENS;
}({});